import * as React from "react";
// import image from "../../../../images/events/beachday.jpeg";

import image from "../../images/events/beachday.jpeg";
import Calendar from "./calendar";


const UpcomingEvent = ({event}) => {
  return (
    <div className="flex flex-col lg:flex-row items-center px-5 py-10 md:px-10 md:py-20 lg:px-24 xl:px-32">
      <div className="md:w-[100%] lg:w-1/2 ">
        <img src={event.image} alt={event.name} className="rounded-xl"></img>
      </div>
      <div className="flex flex-col pt-10 lg:pt-0 lg:pl-10 xl:pl-16 md:w-[100%] lg:w-1/2">
        <div className="flex flex-row items-center">
          <Calendar day={event.day} month={event.month}></Calendar>
          <h2 className="font-bold font-body text-4xl xl:text-5xl pl-8">
            {event.name}
          </h2>
        </div>
        <p className="font-body pt-8 lg:pt-5 xl:pt-10 xl:text-xl">
          {event.description}
        </p>
        <a
          href={event.link}
          target="_blank"
          className="mt-8 lg:mt-5 xl:mt-10 w-[9em] xl:1/12 inline-flex justify-center items-center px-3.5 py-2 font-bold font-lg font-lexend-deca rounded-full text-white bg-blue"
        >
          Sign me up!
        </a>
      </div>
    </div>
  );
};

export default UpcomingEvent;
